import { AppState } from '../../../global/store'
import { Dispatch } from 'react'
import * as accountsApi from '../services/api'
import { Account } from '../store/store'
import { ApiResponse, RequestState } from '../../types'
import { ActionError } from '../../../global/errors'
import moment from 'moment'

import {
  AccountsAction,
  LOAD_ACCOUNTS_ERROR,
  LOAD_ACCOUNTS_REQUEST,
  LOAD_ACCOUNTS_RECEIVED,
  LOAD_ACCOUNT_FILTERS_REQUEST,
  LOAD_ACCOUNT_FILTERS_RECEIVED,
  LOAD_ACCOUNT_FILTERS_ERROR
} from './reducers'

export function loadAccountSearch(partnerId: string, search: string, includeDeactivated: boolean, page: number) {
  return async function(state: AppState, dispatch: Dispatch<AccountsAction>) {
    try {
      dispatch({
        type: LOAD_ACCOUNTS_REQUEST,
        page
      })

      const accountsPerPage = 25
      const accounts: ApiResponse = await accountsApi.getAccountSearchResults(partnerId, search, includeDeactivated, accountsPerPage, page)

      const mappedAccounts: Account[] = accounts.data.map((account: ApiResponse) => {
        return mapAccount(account)
      })

      const totalPages = accounts.meta.pagination.total_pages
      const totalCount = accounts.meta.pagination.total

      dispatch({
        type: LOAD_ACCOUNTS_RECEIVED,
        page,
        accounts: mappedAccounts,
        totalPages,
        totalCount
      })
    } catch (error) {
      throw new ActionError(LOAD_ACCOUNTS_ERROR, error)
    }
  }
}

export function loadAccountFilters(accountId: string) {
  return async function (state: AppState, dispatch: Dispatch<AccountsAction>) {
    try {
      dispatch({
        type: LOAD_ACCOUNT_FILTERS_REQUEST,
        accountId
      })

      const filters = await accountsApi.getFiltersForAccount(accountId)
      const mappedFilters: Account[] = filters.data.map((filter: ApiResponse) => {
        return mapFilter(filter)
      })

      dispatch({
        type: LOAD_ACCOUNT_FILTERS_RECEIVED,
        accountId,
        filters: mappedFilters
      })
    } catch (error) {
      throw new ActionError(LOAD_ACCOUNT_FILTERS_ERROR, error)
    }
  }
}

export function mapAccount(data: ApiResponse) {
  return {
    id: data.id,
    name: data.name,
    records: data.stats.data.records,
    freeRecords: data.stats.data.free_records,
    active: data.active,
    isDemo: data.demo,
    lastActive: data.latest_activity ? moment(data.latest_activity.data.created_at).toDate() : undefined,
    requestState: RequestState.Loading,
    subscription: {
      id: data.subscription.data.id,
      name: data.subscription.data.name,
      active: data.subscription.data.deactivated_at === null || data.subscription.data.deactivated_at === undefined
    }
  }
}

function mapFilter(data: ApiResponse) {
  return {
    id: data.id,
    name: data.name,
    profile: data.profile,
    count: data.count
  }
}
